export default "__VITE_ASSET__CgvxCoMC__"